<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Menu Actions</h4>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Menu List</label>
              <ng-select [items]="ddlMenus" bindValue="value" bindLabel="text" placeholder="Select Menu"
                [loading]="false" [(ngModel)]="selectedMenuId" (change)="GetMenuActions()">
              </ng-select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div style="margin-bottom: 28px;"> </div>
              <button class="btn btn-success" (click)="updateMenuActions()" [disabled]="!CanUpdate"
                role="button">Submit</button>
            </div>
          </div>
          <div class="col-md-4">
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-accordion multi="true">
              <mat-expansion-panel *ngFor="let resource of ResourceAction" [expanded]="resource.Expanded">
                <mat-expansion-panel-header>
                  <mat-panel-title class="custom-title">
                    {{resource.ResourceName}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <section class="accordion-section">
                  <span class="accordion-list-section">
                    <mat-checkbox [id] = "resource.ResourceID"
                                  class="accordion-margin"
                                  [checked]="resource.Selected"
                                  [indeterminate]="someSelected(resource.ResourceID)"
                                  (change)="selectAll(resource.ResourceID,$event.checked)">
                      All
                    </mat-checkbox>
                  </span>
                  <span class="accordion-list-section">
                    <ul>
                      <li *ngFor="let action of resource.actions">
                        <mat-checkbox [(ngModel)]="action.Selected"
                                      (ngModelChange)="updateAllSelected(resource.ResourceID)">
                          {{action.ActionName}}
                        </mat-checkbox>
                      </li>
                    </ul>
                  </span>
                </section>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>